var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWf19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6519 0L5.38807 5.58546L1.56124 5.64827C0.699865 5.66622 0 6.37057 0 7.23643V11.8843C0 12.7681 0.726783 13.4859 1.61059 13.4724L5.4419 13.4096L13.6519 19.0534V0Z",
    fill: "#46324E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6216 4.40107V14.6344C18.1025 14.2485 20.0002 12.1041 20.0002 9.51547C20.0002 6.92687 18.098 4.7869 15.6216 4.39659V4.40107Z",
    fill: "#46324E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf19);
export default __webpack_public_path__ + "static/media/icon-wf-19.f9aa6feca9fb79f656f42616e38a59be.svg";
export { ForwardRef as ReactComponent };